module.exports = __webpack_public_path__ + "static/img/contrato.5db0a46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reserva/contrato.jpg
// module id = 2W05
// module chunks = 1